module.exports = __webpack_public_path__ + "static/media/Amber Merrill.f5a4173a.png";